import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { useOrderContext } from "../../../../contexts/OrderContext";
import { SavedProgressReducerActionTypes } from "../../../../contexts/reducers/savedProgressReducer";
import { IDocument } from "../../../../models/document";
import AddDocumentItemDialog from "../../components/dialogs/AddDocumentItemDialog";
import DocumentItemList from "../../components/itemLists/documentItems/DocumentItemList";
import BaseContent from "../BaseContent";

interface DocumentItemsScreenProps {}

const DocumentItemsScreen = (props: DocumentItemsScreenProps) => {
  const { t } = useTranslation();
  const { savedProgress, dispatchSavedProgress } = useOrderContext();

  const [documentItems, setDocumentItems] = useState<IDocument[]>([]);
  const [showDialog, setShowDialog] = useState(false);
  const [itemToEdit, setItemToEdit] = useState<IDocument | null>(null);

  const loadSavedProgress = () => {
    if (!savedProgress || !savedProgress.documentItems) return;

    setDocumentItems(savedProgress.documentItems);
  };

  const saveProgress = () => {
    dispatchSavedProgress({
      type: SavedProgressReducerActionTypes.SET_PROP,
      property: "documentItems",
      value: documentItems,
    });
  };

  const onEdit = (item: IDocument) => {
    setItemToEdit(item);
    setShowDialog(true);
  };

  const onDelete = (id: string) => {
    setDocumentItems(documentItems.filter((addedItem) => addedItem.id !== id));
  };

  const onSaveNewItem = (newItem: IDocument) => {
    if (itemToEdit) {
      setDocumentItems(
        documentItems.map((item) => (item.id === newItem.id ? newItem : item)),
      );
    } else {
      setDocumentItems([...documentItems, newItem]);
    }
    setShowDialog(false);
    setItemToEdit(null);
  };

  const onCloseDialog = () => {
    setItemToEdit(null);
    setShowDialog(false);
  };

  useEffect(() => {
    loadSavedProgress();
  }, []);

  return (
    <BaseContent
      screenName={"enterItemsScreen"}
      disableNext={false}
      proceedButtonText={t("proceedSummary")}
      saveProgress={saveProgress}
    >
      <div>
        <DocumentItemList
          items={documentItems}
          onAdd={() => setShowDialog(true)}
          onEdit={onEdit}
          onDelete={onDelete}
        />
        {showDialog && (
          <AddDocumentItemDialog
            isOpen={showDialog}
            closeDialog={onCloseDialog}
            onSave={onSaveNewItem}
            itemToEdit={itemToEdit}
          />
        )}
      </div>
    </BaseContent>
  );
};
export default DocumentItemsScreen;
